var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5031 4.20128C17.5031 3.94881 17.6833 3.74414 17.9056 3.74414H21.5283C21.7506 3.74414 21.9308 3.94881 21.9308 4.20128C21.9308 4.45375 21.7506 4.65842 21.5283 4.65842H17.9056C17.6833 4.65842 17.5031 4.45375 17.5031 4.20128Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1574 4.20128C26.1574 3.94881 26.3376 3.74414 26.5599 3.74414H29.9813C30.2036 3.74414 30.3838 3.94881 30.3838 4.20128C30.3838 4.45375 30.2036 4.65842 29.9813 4.65842H26.5599C26.3376 4.65842 26.1574 4.45375 26.1574 4.20128Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.249 21.2365C20.3233 21.1585 20.4208 21.1152 20.522 21.1152H32.5975C32.8198 21.1152 33 21.3199 33 21.5724V32.5439C33 32.7963 32.8198 33.001 32.5975 33.001H1.40252C1.18021 33.001 1 32.7963 1 32.5439V24.3153C1 24.0628 1.18021 23.8582 1.40252 23.8582H17.7483L20.249 21.2365ZM20.6794 22.0295L18.1787 24.6512C18.1043 24.7292 18.0069 24.7725 17.9057 24.7725H1.80503V32.0867H32.195V22.0295H20.6794Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7672 1.45714C27.7672 1.20467 27.9474 1 28.1697 1H29.7798C29.988 1 30.1618 1.18029 30.1807 1.41575L31.7907 21.53C31.8108 21.7814 31.6477 22.0038 31.4263 22.0266C31.2049 22.0495 31.0091 21.8642 30.989 21.6128L29.4122 1.91428H28.1697C27.9474 1.91428 27.7672 1.70961 27.7672 1.45714Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5723 1.45714C28.5723 1.20467 28.3921 1 28.1697 1H26.5597C26.3515 1 26.1777 1.18029 26.1588 1.41575L24.5488 21.53C24.5286 21.7814 24.6918 22.0038 24.9132 22.0266C25.1346 22.0495 25.3304 21.8642 25.3505 21.6128L26.9273 1.91428H28.1697C28.3921 1.91428 28.5723 1.70961 28.5723 1.45714Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3145 1.45714C19.3145 1.20467 19.4947 1 19.717 1H21.327C21.5352 1 21.709 1.18029 21.7279 1.41575L23.338 21.53C23.3581 21.7814 23.1949 22.0038 22.9735 22.0266C22.7521 22.0495 22.5564 21.8642 22.5362 21.6128L20.9594 1.91428H19.717C19.4947 1.91428 19.3145 1.70961 19.3145 1.45714Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1195 1.45714C20.1195 1.20467 19.9393 1 19.717 1H18.1069C17.9003 1 17.7272 1.17771 17.7065 1.4112L15.6939 24.0397C15.6715 24.2909 15.8327 24.5151 16.0539 24.5405C16.2751 24.5658 16.4725 24.3828 16.4948 24.1316L18.4708 1.91428H19.717C19.9393 1.91428 20.1195 1.70961 20.1195 1.45714Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65727 17.7886C7.70664 17.5923 7.86458 17.457 8.0443 17.457H16.4971C16.7194 17.457 16.8996 17.6617 16.8996 17.9142C16.8996 18.1666 16.7194 18.3713 16.4971 18.3713H8.34792L6.82126 24.4397C6.76019 24.6825 6.53741 24.8231 6.32366 24.7537C6.10991 24.6843 5.98614 24.4313 6.04721 24.1886L7.65727 17.7886Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3332 17.9142C22.3332 17.6617 22.5134 17.457 22.7357 17.457H25.1508C25.3731 17.457 25.5533 17.6617 25.5533 17.9142C25.5533 18.1666 25.3731 18.3713 25.1508 18.3713H22.7357C22.5134 18.3713 22.3332 18.1666 22.3332 17.9142Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 29.3419C1 29.0894 1.18021 28.8848 1.40252 28.8848H18.1069C18.3292 28.8848 18.5094 29.0894 18.5094 29.3419C18.5094 29.5944 18.3292 29.799 18.1069 29.799H1.40252C1.18021 29.799 1 29.5944 1 29.3419Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3586 29.3419C26.3586 29.0894 26.5388 28.8848 26.7611 28.8848H27.9686C28.1909 28.8848 28.3712 29.0894 28.3712 29.3419C28.3712 29.5944 28.1909 29.799 27.9686 29.799H26.7611C26.5388 29.799 26.3586 29.5944 26.3586 29.3419Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3773 29.3419C29.3773 29.0894 29.5575 28.8848 29.7798 28.8848H30.9874C31.2097 28.8848 31.3899 29.0894 31.3899 29.3419C31.3899 29.5944 31.2097 29.799 30.9874 29.799H29.7798C29.5575 29.799 29.3773 29.5944 29.3773 29.3419Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3395 29.3419C23.3395 29.0894 23.5197 28.8848 23.742 28.8848H24.9495C25.1718 28.8848 25.3521 29.0894 25.3521 29.3419C25.3521 29.5944 25.1718 29.799 24.9495 29.799H23.742C23.5197 29.799 23.3395 29.5944 23.3395 29.3419Z",
    fill: "#58486C",
    stroke: "#58486C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.2a42da14f53efb1184ea9e6ec460c24d.svg";
export { ForwardRef as ReactComponent };